/* motion: entrance — first-load stagger, once per page load. */
import './entrance.css';

const STEP_MS = 40;
const CAP = 8;
const ENTER_MS = 200; // --ds-dur-base
let played = false;

/**
 * Tags the first items with a stagger index and flips one flag on #app. The CSS keys off the
 * flag, so nodes added later fade in with no delay, and the patcher (which strips inline
 * styles on repaint) never causes a replay: animations only run when a node is created.
 */
export function init(root: HTMLElement): void {
  if (played) return;
  played = true;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  const items = root.querySelectorAll<HTMLElement>(
    '.player-chips .chip, .standings-strip .standings-list li, .game-card',
  );
  items.forEach((el, i) => el.style.setProperty('--enter-delay', `${Math.min(i, CAP) * STEP_MS}ms`));
  root.setAttribute('data-entrance', '');
  // One-shot: drop the flag once the stagger is done so later week changes (which have their
  // own View Transition cross-fade) never replay a second fade on new cards.
  setTimeout(() => root.removeAttribute('data-entrance'), CAP * STEP_MS + ENTER_MS + 150);
}
